import { FC, useEffect, useState } from 'react';
import { IBasicProductsCare, IProductsCare } from '../../../../../../types/bussines';
import { BlackCheckIcon } from '../../../../../../assets/images/countryList';
import { InternalIcon, ExternalIcon } from 'assets/images/bussines';
import { formatShortDate } from '../../../../../../utils/formatDatesAndHours';
import { REFERENCE_MODEL_TYPE } from '../../../../../../types/global';
import './NudosCareCard.scss';

interface INudosCareCard {
  dataCareCard: IProductsCare;
  isEditable: boolean;
  handleEditProductsCare: (e: IBasicProductsCare) => void;
}

type TNudosCarePlan = 'Free' | 'Basic' | 'Log' | 'Full';

/**
 * Tarjeta de Nudos Care con selección de planes (Free, Basic, Log, Full).
 */
const NudosCareCard: FC<INudosCareCard> = ({ dataCareCard, isEditable, handleEditProductsCare }) => {
  const [nudosCareLevel, setNudosCareLevel] = useState<TNudosCarePlan>();

  useEffect(() => {
    if (dataCareCard?.nudosCare) {
      setNudosCareLevel(dataCareCard.nudosCare);
    }
  }, [dataCareCard]);

  /**
   * Actualiza el plan seleccionado y lo registra en el listado editable del tab.
   */
  const handleCareLevelChange = (careLevel: TNudosCarePlan, careValue: number) => {
    setNudosCareLevel(careLevel);
    handleEditProductsCare({ nudosCare: careValue, productId: dataCareCard.productId });
  };

  const renderCareCheckbox = (careLevel: TNudosCarePlan, careValue: number, label: string, extraClassName = '') => {
    const isSelected = nudosCareLevel === careLevel;
    const canEdit = isEditable && !dataCareCard?.isKit;

    return (
      <div className={`containerCheck ${extraClassName}`}>
        {isSelected ? (
          <div className="containerLevel">{dataCareCard?.isKit ? <div className="blockCheck" /> : <BlackCheckIcon />}</div>
        ) : (
          <>
            {canEdit ? (
              <div className="checkEnabled" onClick={() => handleCareLevelChange(careLevel, careValue)} />
            ) : (
              <>{dataCareCard?.isKit ? <div className="blockCheck" /> : <div className="noCheck" />}</>
            )}
          </>
        )}
        <div className={`fontCheck ${(isSelected || isEditable) && !dataCareCard?.isKit ? 'selectLevel' : ''}`}>
          {label}
        </div>
      </div>
    );
  };

  const formattedStartDate = dataCareCard?.startDate ? formatShortDate(dataCareCard.startDate)?.textWithTimezone : null;
  const formattedEndDate = dataCareCard?.endDate ? formatShortDate(dataCareCard.endDate)?.textWithTimezone : null;

  return (
    <div id="nudosCareCard" className="nudosCareCardPlans">
      <div className="pointName">
        <div className="blackPoint" />
      </div>
      <div className="toolName">
        {`${dataCareCard?.serial ? `${dataCareCard?.serial} /` : ''} ${dataCareCard.nudosId} - ${
          dataCareCard.productName
        }`}
        <div className="containerTypeTool">
          {dataCareCard.referenceCatalog === REFERENCE_MODEL_TYPE.INTERNAL && <InternalIcon />}
          {dataCareCard.referenceCatalog === REFERENCE_MODEL_TYPE.EXTERNAL && <ExternalIcon />}
          {dataCareCard.referenceCatalog === REFERENCE_MODEL_TYPE.STOCK && <InternalIcon />}
        </div>
      </div>
      <div className="containerChecks">
        {renderCareCheckbox('Free', 1, 'Free', 'mr-32')}
        {renderCareCheckbox('Basic', 2, 'Basic', 'mr-32')}
        {renderCareCheckbox('Log', 3, 'Log.', 'mr-32')}
        {renderCareCheckbox('Full', 4, 'Full')}
      </div>
      <div className="dateCareContainer">
        <div className="dateCareDisplayRow">
          <div className="startCareDate">
            {formattedStartDate ? (
              <div className="startDate">{`Inicio: ${formattedStartDate}`}</div>
            ) : (
              <div className="noStartDate">Inicio: -</div>
            )}
          </div>
          <div className="endCareDate">
            {formattedEndDate ? (
              <div className="endDate">{`Fin: ${formattedEndDate}`}</div>
            ) : (
              <div className="noEndDate">Fin: -</div>
            )}
          </div>
        </div>
      </div>
      <div className="grayLine" />
    </div>
  );
};

export default NudosCareCard;
